<template lang="pug">
div
    div(v-if="!intakeAssessment.new_GeneralApplication_IntakeAssessment_n.length && !intakeAssessment.new_ExoffenderApplication_IntakeAssessmen.length")
        b-alert(show variant="danger") Application form could not be found in the system. The client application may not have been through the system.
    div(v-else)
        div(v-if="intakeAssessment.new_ReferringAgency_IntakeAssessment_new_.length > 0")
            h2 Referring Agency
            div
                b Case ref (if any)
                p {{getValue(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_caseref)}}
            div
                b Name of Agency
                p {{getValue(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_agency)}}
            div
                b Name of Social Worker
                p {{getValue(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_socialworkername)}}
            div
                b Contact No.
                p {{getValue(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_contactnumber)}}
            div
                b Email
                p {{getValue(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_email)}}
            div
                b Type of services rendered to client being referred
                p {{getValue(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_servicetype)}}
            div
                b How long have you been working with client?
                p {{ intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_workingwithclientduration/1440 > 30 ? Math.round(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_workingwithclientduration/43800)+' months' : Math.round(intakeAssessment.new_ReferringAgency_IntakeAssessment_new_[0].new_workingwithclientduration/1440)+' days'}}
            
            div(v-if="intakeAssessment.new_GeneralApplication_IntakeAssessment_n.length > 0")
                input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_applicationclientconsent")
                | I declare that consent has been granted by the client to allow his/her personal data to be collected, used and disclosed to TS for the purpose of applying for shelter assistance.
            div(v-if="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen.length > 0")
                input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_applicationclientconsent")
                | I declare that consent has been granted by the client to allow his/her personal data to be collected, used and disclosed to TS for the purpose of applying for shelter assistance.

        div.break-before
            h2.mt-5 Admission criteria
            p Referring agencies should assess that applicant and family members, if applicable, meet the admission criteria and tick where applicable.
            h3 {{ intakeAssessment.new_admissiontype == 100000002 ? 'Do the applicant fulfil the following?' : 'Do the applicant and all members of the family (if applicable) fulfil the following?' }}

            div(v-if="intakeAssessment.new_admissiontype != 100000002")
                table.table
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_iscitizen")
                        | Singapore Citizen or Permanent Resident (if applying as a family, at least one member of the family must be a Singapore Citizen)

                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_atriskhomeless")
                        | Currently or at risk of being homeless
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_exhaustedaccommodationmeans")
                        | Exhausted all other means of accommodation
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_facingfinancialdifficulties")
                        | Facing financial difficulties
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_noteligiblepublichousing")
                        | Not eligible for any public housing options
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_noinfectiousdisease")
                        | Free from serious infectious diseases that may be easily transmitted in a communal setting
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_nopsychoticbehaviourmedicalproblem")
                        | Not suffering from serious psychotic disorders, and/or serious behavioural problems, and/ or serious medical conditions requiring close supervision or nursing care
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_noactivesubstancealcoholabuser")
                        | Not active substance or alcohol abusers
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_willingtoworkwithts")
                        | Willing to work with the Transitional Shelter on case goals and intervention plan, and be motivated to be self-reliant
                hr
                label(for="criteriaelaboration") If any of the above criteria are not met, please state brief reason(s) to support this application below and elaborate in social report:
                div.border.rounded.p-2(style="min-height:4em") {{intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_criteriaelaboration}}
            div(v-if="intakeAssessment.new_admissiontype == 100000002")
                table.table
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_iscitizen")
                        | The applicant is a Singaporean citizen or Singapore Permanent Resident.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_above18")
                        | The applicant is above 18 years old.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_noinfectiousdisease")
                        | The applicant is free from infectious diseases.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_noactivesubstancealcoholabuser")
                        | The applicant is not abusing drugs/alcohol currently.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_nopsychoticbehaviourmedicalproblem")
                        | The applicant is not suffering from serious psychotic disorders and/or serious behavioral problems that require close individual supervisions or nursing care.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_atriskhomeless")
                        | The applicant is rendered homeless and/or in crisis.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_exhaustedaccommodationmeans")
                        | The applicant has explored other options with kinship support but to no avail.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_fitforemployment")
                        | The applicant is currently employed/fit for employment.
                    div
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_abletopayshelterfees")
                        | The applicant can pay monthly shelter fees (SGD $100 per month, excluding utilities).
                
                div
                    b Requested date of admission into shelter
                    p {{intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_requestedadmissiondate ? dayjs(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_requestedadmissiondate).format('DD/MM/YYYY') : 'N/A'}}
                div
                    b Requested length of time in shelter
                    p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_requestedtimeinshelter)}}

        div.break-before
            h2.mt-5 Particulars of main applicant
            table.table
                tr
                    td(colspan=2)
                        b Name
                        p {{getValue(client.new_name)}}
                tr
                    td
                        b NRIC
                        p {{getValue(client.new_nric)}}
                    td
                        b Citizenship 
                        p
                            | {{!client.new_citizenship ? 'N/A' : ''}}
                            | {{client.new_citizenship === 100000000 ? 'Singapore' : ''}}
                            | {{client.new_citizenship === 100000001 ? 'Singapore PR' : ''}}
                            | {{client.new_citizenship === 100000002 ? 'Others' : ''}}
                tr
                    td
                        b Date of Birth 
                        p {{dayjs(client.new_birthdate).format('DD/MM/YYYY')}}
                    td
                        b Gender 
                        p
                            | {{!client.new_gender ? 'N/A' : ''}}
                            | {{client.new_gender === 100000000 ? 'Male' : ''}}
                            | {{client.new_gender === 100000001 ? 'Female' : ''}}
                            
                tr
                    td
                        b Contact Number
                        p {{getValue(client.new_contactnumber)}}
                    td
                        b Email 
                        p {{getValue(client.new_email)}}
                tr
                    td(colspan=2)
                        b NRIC Address
                        p {{getValue(client.new_nricaddress)}}
                tr
                    td
                        b Marital Status
                        p
                            | {{!client.new_maritalstatus ? 'N/A' : ''}}
                            | {{client.new_maritalstatus === 100000000 ? 'Married' : ''}}
                            | {{client.new_maritalstatus === 100000001 ? 'Divorced' : ''}}
                            | {{client.new_maritalstatus === 100000002 ? 'Separated' : ''}}
                            | {{client.new_maritalstatus === 100000003 ? 'Widowed' : ''}}
                            | {{client.new_maritalstatus === 100000004 ? 'Single' : ''}}
                            | {{client.new_maritalstatus === 100000005 ? 'Others' : ''}}
                    td
                        div.d-flex.justify-content-between
                            div
                                b If Others, to indicate: 
                                p {{getValue(client.new_maritalstatusother)}}
                            div
                                b Number of Children 
                                p {{getValue(client.new_totalchildren)}}
                tr
                    td
                        b Language
                        p
                            | {{!client.new_language ? 'N/A' : ''}}
                            | {{client.new_language === 100000000 ? 'English' : ''}}
                            | {{client.new_language === 100000001 ? 'Mandarin' : ''}}
                            | {{client.new_language === 100000002 ? 'Malay' : ''}}
                            | {{client.new_language === 100000003 ? 'Tamil' : ''}}
                            | {{client.new_language === 100000004 ? 'Others' : ''}}
                    td
                        b If Others, to indicate: 
                        p {{getValue(client.new_languageother)}}
                tr
                    td
                        b Race
                        p
                            | {{!client.new_race ? 'N/A' : ''}}
                            | {{client.new_race === 100000000 ? 'Chinese' : ''}}
                            | {{client.new_race === 100000001 ? 'Malay' : ''}}
                            | {{client.new_race === 100000002 ? 'Indian' : ''}}
                            | {{client.new_race === 100000003 ? 'Others' : ''}}
                    td
                        b If Others, to indicate: 
                        p {{getValue(client.new_raceother)}}
                tr
                    td
                        b Religion
                        p
                            | {{!client.new_religion ? 'N/A' : ''}}
                            | {{client.new_religion === 100000000 ? 'Buddhism' : ''}}
                            | {{client.new_religion === 100000001 ? 'Taoism' : ''}}
                            | {{client.new_religion === 100000002 ? 'Islam' : ''}}
                            | {{client.new_religion === 100000003 ? 'Hinduism' : ''}}
                            | {{client.new_religion === 100000004 ? 'Christianity' : ''}}
                            | {{client.new_religion === 100000005 ? 'No religion' : ''}}
                            | {{client.new_religion === 100000006 ? 'Others' : ''}}
                    td
                        b If Others, to indicate: 
                        p {{getValue(client.new_religionother)}}
                tr
                    td
                        b Education
                        p
                            | {{!client.new_education ? 'N/A' : ''}}
                            | {{client.new_education === 100000000 ? 'None' : ''}}
                            | {{client.new_education === 100000001 ? 'PSLE' : ''}}
                            | {{client.new_education === 100000002 ? 'N Level' : ''}}
                            | {{client.new_education === 100000003 ? 'O Level' : ''}}
                            | {{client.new_education === 100000004 ? 'NITEC' : ''}}
                            | {{client.new_education === 100000005 ? 'Higher NITEC' : ''}}
                            | {{client.new_education === 100000006 ? 'A Level' : ''}}
                            | {{client.new_education === 100000007 ? 'Diploma' : ''}}
                            | {{client.new_education === 100000008 ? 'Degree or higher' : ''}}
                            | {{client.new_education === 100000009 ? 'Others' : ''}}
                    td
                        b If Others, to indicate: 
                        p {{getValue(client.new_educationother)}}
                tr
                    td(colspan=2)
                        b Employment status
                        p
                            | {{!client.new_employmentstatus ? 'N/A' : ''}}
                            | {{client.new_employmentstatus === 100000000 ? 'Working' : ''}} 
                            | {{client.new_employmentstatus === 100000001 ? 'Looking for work' : ''}} 
                            | {{client.new_employmentstatus === 100000002 ? 'Not looking for work (homemaker/caregiver)' : ''}} 
                            | {{client.new_employmentstatus === 100000003 ? 'Not looking for work (temporarily medically unfit)' : ''}} 
                            | {{client.new_employmentstatus === 100000004 ? 'Not looking for work (permanently medically unfit)' : ''}} 
                            | {{client.new_employmentstatus === 100000005 ? 'Not looking for work (retired)' : ''}} 
                            | {{client.new_employmentstatus === 100000006 ? 'Not looking for work (others)' : ''}} 
                tr
                    td
                        b Occupation
                        p {{getValue(client.new_occupation)}}
                    td
                        b Monthly salary
                        p {{getValue(client.new_monthlysalary)}}
                tr
                    td
                        b Employment type
                        p
                            | {{client.new_employmenttype === 100000000 ? 'Full-time' : ''}} 
                            | {{client.new_employmenttype === 100000001 ? 'Part-time' : ''}} 
                            | {{client.new_employmenttype === 100000002 ? 'Hourly-rated' : ''}} 
                            | {{client.new_employmenttype === 100000003 ? 'Others' : ''}} 
                            | {{client.new_employmenttype === 100000004 ? 'NA' : ''}} 
                    td
                        b If Others, to indicate: 
                        p {{getValue(client.new_employmenttypeother)}}
                tr
                    td(colspan=2)
                        h5.m-0 <b>Duration of employment</b>
                tr
                    td
                        b From
                        p {{client.new_employmentstart ? dayjs(client.new_employmentstart).format('DD/MM/YYYY') : 'N/A'}}
                    td
                        b to
                        p {{client.new_employmentend ? dayjs(client.new_employmentend).format('DD/MM/YYYY') : 'N/A'}}
                tr(v-if="intakeAssessment.new_admissiontype == 100000002")
                    td(colspan=2)
                        b Earliest Date Of Release (EDR)
                        p {{intakeAssessment.new_IntakeClient_IntakeAssessment_new_Int[0].new_prisonedr ? dayjs(intakeAssessment.new_IntakeClient_IntakeAssessment_new_Int[0].new_prisonedr).format('DD/MM/YYYY') : 'N/A'}}
                tr(v-if="intakeAssessment.new_admissiontype == 100000002")
                    td(colspan=2)
                        b Prison Inmate Number
                        p {{getValue(client.new_prisoninmatenumber)}}

        div(v-if="intakeAssessment.new_admissiontype == 100000002")
            h2.mt-5 Aftercare Case Manager (If any)
            div
                b Name
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_casemanagername)}}
            div
                b Designation
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_casemanagerdesignation)}}
            div
                b Agency
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_casemanageragency)}}
            div
                b Contact Number
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_casemanagercontactnumber)}}
            div
                b Email
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_casemanageremail)}}
            
            h2.mt-5 Emergency Contact Numbers (Please list two persons)
            b-table(:items="client.new_IntakeEmergencyContact_IntakeClient_n" :fields="fields.emergencyContactFields")

        div(v-if="intakeAssessment.new_admissiontype == 100000001 || intakeAssessment.new_admissiontype == 100000002")
            h2.mt-5(v-if="intakeAssessment.new_admissiontype == 100000001") Particulars of immediate family members applying for shelter admission
            h2.mt-5(v-if="intakeAssessment.new_admissiontype == 100000002") Family Composition
            b-table(:items="client.new_IntakeFamilyMember_IntakeClient_new_I" :fields="fields.familyFields")
                template(#cell(new_school)='data')
                    div <b>{{ data.item.new_school }}</b>
                    | {{ data.item.new_schoollevel === 100000000 ? 'Primary,' : ''}} 
                    | {{ data.item.new_schoollevel === 100000001 ? 'Secondary,' : ''}} 
                    | {{ data.item.new_schoollevel === 100000002 ? 'Polytechnic,' : ''}} 
                    | {{ data.item.new_schoollevel === 100000003 ? 'University,' : ''}} 
                    span(v-if="data.item.new_schoolyear") Year {{ data.item.new_schoolyear }}
                template(#cell(new_gender)='data')
                    | {{data.item.new_gender === 100000000 ? 'Male' : ''}}
                    | {{data.item.new_gender === 100000001 ? 'Female' : ''}}
                template(#cell(new_citizenship)='data')
                    | {{data.item.new_citizenship === 100000000 ? 'Singapore' : ''}}
                    | {{data.item.new_citizenship === 100000001 ? 'Others' : ''}}

        h2.mt-5 Housing History
        b-table(:items="client.new_IntakeHousingHistory_IntakeClient_new" :fields="fields.housingFields")
            template(#cell(new_ownershipstatus)='data')
                | {{ data.item.new_ownershipstatus === 100000000 ? 'Owner' : ''}} 
                | {{ data.item.new_ownershipstatus === 100000001 ? 'Tenant' : ''}} 
                | {{ data.item.new_ownershipstatus === 100000002 ? 'Occupier' : ''}}
            template(#cell(new_staystart)='data')
                | {{ dayjs(data.item.new_staystart).format('DD/MM/YYYY') }} to {{ dayjs(data.item.new_stayend).format('DD/MM/YYYY') }}

        <!-- General Application Form -->
        div(v-if="intakeAssessment.new_admissiontype == 100000000 || intakeAssessment.new_admissiontype == 100000001")
            h2.mt-5 Debarment
            p Leave blank if not relevant to the applicant and/or family members
            div
                b Type of debarment / reason for debarment
                p {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_debarmenttype)}}
            div
                b Name(s) of person with debarment
                p {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_debarmentperson)}}
            div
                b Debarment period
                p {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_debarmentperiod)}}
            div
                b Start date of debarment
                p {{intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_debarmentstart ? dayjs(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_debarmentstart).format('DD/MM/YYYY') : 'N/A'}}

            h2.mt-5 Current Housing Situation
            div
                b Current/most recent address
                p {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_recentaddress)}}
            div
                b Source of accommodation
                p {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_accommodationsource)}}
            div
                b Start date
                p {{intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_housingstartdate ? dayjs(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_housingstartdate).format('DD/MM/YYYY') : 'N/A'}}
            div
                b Estimated date to leave
                p {{intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_housingleavedate ? dayjs(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_housingleavedate).format('DD/MM/YYYY') : 'N/A'}}
            
            h2.mt-5 Main presenting issues
            p To indicate presence of risks and main presenting issues per your assessment of applicant/family members, and to elaborate in the social report
            div
                b Reason for homelessness (eg. bankruptcy resulting in losing purchase flat)
                p {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_homelessreason)}}
            div.break-before
                b Main presenting issue (excluding accommodation needs; if not available on drop-down, to briefly describe)
                table
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000000")
                        | Financial issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000001")
                        | Employment issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000002")
                        | Health issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000003")
                        | Marital issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000004")
                        | Legal issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000005")
                        | Parenting issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000006")
                        | Inter-personal issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000007")
                        | Caregiving issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000008")
                        | Family issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000009")
                        | Elderly issues
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000010")
                        | Family violence
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000011")
                        | Addiction
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000012")
                        | Parent-child management
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissue == 100000013")
                        | Others
                    tr: td
                        label(for="mainissueother") If others, to indicate
                        div.border.rounded.p-2(style="min-height:4em") {{intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_mainpresentingissueother}}
            div
                h3.mt-3 Secondary Presenting Issues
                div(v-if="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues")
                table
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000000') : false")
                        | Financial issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000001') : false")
                        | Employment issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000002') : false")
                        | Health issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000003') : false")
                        | Marital issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000004') : false")
                        | Legal issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000005') : false")
                        | Parenting issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000006') : false")
                        | Inter-personal issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000007') : false")
                        | Caregiving issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000008') : false")
                        | Family issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000009') : false")
                        | Elderly issues
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000010') : false")
                        | Family violence
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000011') : false")
                        | Addiction
                    tr: td 
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000012') : false")
                        | Parent-child management
                    tr: td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues ? intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissues.includes('100000013') : false")
                        | Others
                    tr: td
                        label(for="secondaryissueother") If others, to indicate
                        div.border.rounded.p-2(style="min-height:4em") {{intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_secondarypresentingissueother}}
            div.py-3
            b To indicate if applicant/family members have mental health concerns and/or medical issues
            div Names: {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_medicalissueperson)}}
            p Describe briefly: {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_medicalissuedescription)}}
            b To indicate if applicant/family members have prior incarceration or drug abuse background
            div Names: {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_incarcerationdrugperson)}}
            p Describe briefly: {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_incarcerationdrugdescription)}}
            div
                b To indicate if there are any other risks to alert the TS
                p {{getValue(intakeAssessment.new_GeneralApplication_IntakeAssessment_n[0].new_otherrisks)}}

        <!-- Ex-offender form table/history -->
        div(v-if="intakeAssessment.new_admissiontype == 100000002")
            h2.mt-5 Forensic/Criminal History
            div
                input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_sexualassaulthistory")
                b History of sexual assault
            div
                b Please specify
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_sexualassaulthistorydescription)}}
            div
                input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_violencehistory")
                b History of violent/hostile/aggressive behaviour
            div
                b Please specify
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_violencehistorydescription)}}
            h3 Incarceration History
            b-table(:items="client.new_IntakeIncarcerationHistory_IntakeClie" :fields="fields.incarcerationHistoryFields")
                template(#cell(new_incarcerationstart)='data')
                    | {{dayjs(data.item.new_incarcerationstart).format('MM/YYYY')}} to {{dayjs(data.item.new_incarcerationend).format('MM/YYYY')}}

            h2.mt-5 History of Substance use and Dependency
            div
                b Types of substances taken
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_substanceusedtype)}}
            div
                b Frequency of use
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_substanceusedfrequency)}}
            div
                b Number of times in DRC
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_timesindrc)}}
            div
                b Details of Offences
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_substanceoffencesdetail)}}
            div
                b Urine Test (UT) days
                p(v-if="!intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestday") N/A
                div(v-if="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestday")
                    b-badge.mr-1.mb-1(variant="secondary") {{intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestday.includes("100000000") ? 'Monday' : ''}}
                    b-badge.mr-1.mb-1(variant="secondary") {{intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestday.includes("100000001") ? 'Tuesday' : ''}}
                    b-badge.mr-1.mb-1(variant="secondary") {{intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestday.includes("100000002") ? 'Wednesday' : ''}}
                    b-badge.mr-1.mb-1(variant="secondary") {{intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestday.includes("100000003") ? 'Thursday' : ''}}
                    b-badge.mr-1.mb-1(variant="secondary") {{intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestday.includes("100000004") ? 'Friday' : ''}}
            div
                b Location of UT
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_urinetestlocation)}}
            
            h2.mt-5 Mental/Medical Health Issue
            div
                b Current Mental/Medical Health issue
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_healthissue)}}
            div
                input.mr-1(type="checkbox" :checked="intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_healthimpactdailyfunctioning")
                b Active/impact daily functioning
            div
                b Please specify your answer
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_healthimpactdailyfunctioningdescription)}}
            h3 Medication
            b-table(:items="client.new_IntakeMedication_IntakeClient_new_Int" :fields="fields.medicationFields")

            h2.mt-5 Systems client known to
            b-table(:items="client.new_IntakeSystem_IntakeClient_new_IntakeC" :fields="fields.systemFields")

            h2.mt-5 Assessment
            div
                b Motivation level to work on securing full-time employment
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_employmentmotivation)}}
            div
                b Motivation level to work on housing plan
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_housingplanmotivation)}}
            div
                b Strengths
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_strengths)}}
            div
                b Potential challenges
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_potentialchallenges)}}
            div
                b Additional remarks about client
                p {{getValue(intakeAssessment.new_ExoffenderApplication_IntakeAssessmen[0].new_remark)}}
        
        <!-- Checklist -->
        h2.mt-5 Checklists
        div(v-if="intakeAssessment.new_admissiontype != 100000002")
            table.table
                thead
                    th
                        h5.m-0 Have you informed the applicant on the following
                    th
                        h5.m-0 Remarks
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedstaymaximum6month")
                        | Shelter stay, if approved, for a maximum of 6 months
                    td {{getValue(intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedstaymaximum6monthremark)}}
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedcosharing")
                        | Shelter stay will involve co-sharing of the designated shelter unit
                    td {{getValue(intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedcosharingremark)}}
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedshelterfeesutility")
                        | Payment of shelter fees and co-sharing of utility costs during shelter stay
                    td {{getValue(intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedshelterfeesutilityremark)}}
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedworkwithts")
                        | Admitted families/individuals must work with the TS on their housing and other needs
                    td {{getValue(intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_informedworkwithtsremark)}}
                thead
                    th(colspan="2")
                        h5.m-0 Additional questions
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_referrerattendintakeinterview")
                        | Will you be present for the intake interview?

                    td {{getValue(intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_referrerattendintakeinterviewremark)}}
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_agreetransfercasetots")
                        | Do you agree to transfer the case to TS for case management? (If no, please provide reasons)
                    td {{getValue(intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_transfercasedisagreereason)}}
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_referrercontinueotherservices")
                        | Will you continue to render other services to the client (e.g. group work)?
                    td {{getValue(intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_referrercontinueotherservicesremark)}}
                tr
                    td
                        input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_referotherts")
                        | Did you refer client to another TS? (If yes, to select from drop-down. Ctrl+click to select multiple TS)
                    td
                        p(v-if="!intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_othertsreferred") N/A
                        div(v-if="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_othertsreferred")
                            div {{intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_othertsreferred.includes("100000000") ? 'AMKFSC Transition Plus' : ''}}
                            div {{intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_othertsreferred.includes("100000001") ? 'AWWA Transitional Shelter' : ''}}
        
        h4.mt-3 Checklist for social report to be submitted
        p Please use the checklist to ensure you have provided the below information for the main applicant and family members applying for shelter admission in the accompanying social report.
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_familybackgroud")
            | Family background (including genogram and ecomap)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_housinghistory")
            | Timeline of homeownership / housing history (to include places of residence and reasons for displacement)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_currenthousingsituation")
            | Current housing situation and attempted efforts to resolve housing issue
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_applicantneeds")
            | Needs of applicant and family members (e.g. relationships, health, caregiving ability)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_applicantrisk")
            | Risks of applicant and family members (eg. safety concerns and risk behaviours)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_employmentfinancialsituation")
            | Employment and financial situation
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_physicalandmentalhealthstatus")
            | Physical and mental health status
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_assistancereceived")
            | Current/previous assistance received by and social support of applicant and family members (to include financial assistance)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_referringagencyintervention")
            | Previous/current intervention by referring agency (to include efforts in seeking alternative accommodation)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sr_assessment")
            | Assessment (including identification of suitable long-term housing that applicant and family members can work towards to)

        h4.mt-3 Checklist for supporting documents (check any relevant document)
        p Please provide the relevant supporting documents with your application.
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_applicantnricorbc")
            | NRIC of applicant, family members applying for admission, BC of children (without NRICs)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_applicantcpf")
            | CPF statement of applicant and all family members above 18 years old (such as transaction history statement and contribution history for past 15 months)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_iestatement")
            | I&E statement
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_lettersfromhdb")
            | Relevant letters from HDB (sale of flat, correspondence on HDB appeals, etc)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_maritalstatusdocument")
            | Marriage certificate, divorce certificate, deed of separation, or proof of divorce proceedings
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_cashproceeds")
            | Breakdown of cash proceeds (for previous homeowners)
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_employmentproof")
            | Employment letters, payslips or other indicators of income for last 3 months
        div
            input.mr-1(type="checkbox" :checked="intakeAssessment.new_DocumentChecklist_IntakeAssessment_ne[0].new_sd_medicalcertificates")
            | Medical certificates/memos on physical/mental health (where relevant)

</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'ApplicationDocument',
    props: {
        intakeAssessment: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data(){
        return{
            fields: {
                familyFields:[
                    { key: 'new_name', label: 'Name', sortable: true },
                    { key: 'new_age', label: 'Age', sortable: true },
                    { key: 'new_gender', label: 'Gender', sortable: true },
                    { key: 'new_citizenship', label: 'Citizenship', sortable: true },
                    { key: 'new_occupation', label: 'Occupation', sortable: true },
                    { key: 'new_income', label: 'Income', sortable: true },
                    { key: 'new_school', label: 'School' },
                ],
                housingFields:[
                    { key: 'new_housingtype', label: 'Type', sortable: true },
                    { key: 'new_address', label: 'Address', sortable: true },
                    { key: 'new_ownershipstatus', label: 'Owner/Tenant or Occupier', sortable: true },
                    { key: 'new_exitreason', label: 'Reason for Exit', sortable: true },
                    { key: 'new_staystart', label: 'Duration of Stay', sortable: true },
                ],
                emergencyContactFields:[
                    { key: 'new_name', label: 'Name', sortable: true },
                    { key: 'new_relationship', label: 'Relationship', sortable: true },
                    { key: 'new_contactnumber', label: 'Contact Number', sortable: true },
                ],
                incarcerationHistoryFields:[
                    { key: 'new_offencenumber', label: 'Offence Number', sortable: true },
                    { key: 'new_offencetype', label: 'Type of Offence', sortable: true },
                    { key: 'new_incarcerationstart', label: 'Period of Incarceration', sortable: true },
                ],
                medicationFields:[
                    { key: 'new_name', label: 'Name of Medication', sortable: true },
                    { key: 'new_consumptioninstruction', label: 'Consumption Instructions', sortable: true },
                ],
                systemFields:[
                    { key: 'new_organisationname', label: 'Name of Organisation', sortable: true },
                    { key: 'new_assistancetype', label: 'Type of Assisstance', sortable: true },
                    { key: 'new_officerincharge', label: 'Officer-in-Charge', sortable: true },
                    { key: 'new_email', label: 'Email', sortable: true },
                    { key: 'new_contactnumber', label: 'Contact Number', sortable: true },
                ],
            }
        }
    },
    mounted() {
    },
    methods: {
        dayjs,
        getValue(value) {
            return value ? value : 'N/A';
        }
    }
}
</script>

<style>

</style>